import React from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import { Box } from '@procore/core-react';

const WistiaImage = styled.img`
  filter: blur(5px);
  height: 100%;
  object-fit: contain;
  width: 100%;
`;

const WistiaEmbed = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const VideoPreview = ({ wistiaId }) => {
  return (
    <WistiaEmbed
      className={`wistia_embed wistia_async_${wistiaId} videoFoam=true`}
    >
      <Box className="wistia_swatch">
        <WistiaImage
          src={`https://fast.wistia.com/embed/medias/${wistiaId}/swatch`}
          alt=""
          aria-hidden="true"
        />
      </Box>
    </WistiaEmbed>
  );
};

VideoPreview.propTypes = {
  wistiaId: PT.string,
};
